import React from 'react';
import { FaCode } from 'react-icons/fa';

import {PaperDarkBG } from "../kits/DesignKit";


function SectionZen() {
  return (
   
  
    <PaperDarkBG>
      {/* Die oben definierte Section */}
      <section className=" py-20 sm:py-16 md:py-20">
        <div className="container mx-auto text-center px-10">
          <div className="text-sm sm:text-xl md:text-xl font-mono text-gray-50 mb-4">
            <span className="text-brand">ZenDev </span>
            <span> App | Medien & Sofwarelösungen </span> 
          </div>
          
          <p className="italic text-xs font-mono sm:text-xs md:text-xs text-gray-50">
         Denis Bitter
          </p>
        </div>
      </section>
      
      {/* Weitere Sections oder Inhalte hier */}
    </PaperDarkBG>
    
  );
}

export default SectionZen;